<template>
  <div>
    <div class="form-group">
      <ul role="tablist" class="nav nav-tabs">
        <li v-for="(language, i) in languages" v-bind:key="i" v-bind:class="{'active': language.active}"
            role="presentation">
          <a href="#"
             v-on:click.prevent="setActiveLanguage(language.id)"
             role="tab"
             aria-controls="content"
             v-bind:aria-expanded="language.active">
            {{ language.name }}
          </a>
        </li>
        <li v-if="availableLanguages.length &gt; 0" role="presentation" class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
             aria-expanded="false">
            <i class="fal fa-plus"></i> Add
          </a>
          <ul class="dropdown-menu">
            <li v-for="(availableLanguage, i) in availableLanguages" v-bind:key="i">
              <a href="#" v-on:click.prevent="addLanguage(availableLanguage.id)"
                 class="add-button">{{ availableLanguage.name }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <div v-for="(language, i) in languages" v-bind:key="i"
           role="tabpanel"
           v-bind:class="'tab-pane' + (language.active ? ' active' : '')">
        <div v-if="languages.length &gt; 1" class="form-group">
          <a href="#" v-on:click.prevent="removeLanguage(language.id)" class="remove-button"><i
              style="margin-right: 5px;" class="fal fa-times"></i>Remove {{ language.name }}</a>
        </div>
        <slot name="content" v-bind:language="language"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "language-tabs",
  props: {
    id: null,
    defaultLanguageId: {
      type: String,
      required: false
    },
    availableLanguages: {
      type: Array,
      required: true
    },
    languages: {
      type: Array,
      required: false,
      default: function () {
        return [];
      }
    },
    languageAdded: {
      type: Function,
      required: false
    },
    languageRemoved: {
      type: Function,
      required: false
    }
  },
  methods: {
    addAvailableLanguages: function (languages) {
      for (var i = 0; i < languages.length; i++) {
        var language = languages[i];
        language.active = false;
        this.availableLanguages.push(language);
      }
    },
    addLanguage: function (id) {
      var language;
      for (var i = 0; i < this.availableLanguages.length; i++) {
        if (id === this.availableLanguages[i].id) {
          language = this.availableLanguages.splice(i, 1)[0];
          this.languages.push(language);
          break;
        }
      }
      for (var j = 0; j < this.languages.length; j++) {
        this.$set(this.languages[j], "active", this.languages[j].id === id);
      }
      if (this.languageAdded) {
        this.languageAdded(language);
      }
    },
    removeLanguage: function (id) {
      var language;
      for (var i = 0; i < this.languages.length; i++) {
        this.languages[i].active = false;
        if (id === this.languages[i].id) {
          language = this.languages.splice(i, 1)[0];
          this.availableLanguages.push(language);
        }
      }
      if (this.languages.length > 0) {
        this.languages[0].active = true;
      }
      if (this.languageRemoved) {
        this.languageRemoved(language);
      }
    },
    setActiveLanguage: function (id) {
      for (var i = 0; i < this.languages.length; i++) {
        this.$set(this.languages[i], "active", this.languages[i].id === id);
      }
    },
    reset: function () {
      for (var i = 0; i < this.languages.length; i++) {
        this.removeLanguage(this.languages[i--].id);
      }
      if (this.defaultLanguageId) {
        this.addLanguage(parseInt(this.defaultLanguageId));
      }
    }
  },
  mounted: function () {
    if (this.defaultLanguageId) {
      this.addLanguage(parseInt(this.defaultLanguageId));
    }
  }
}
</script>
